import { FeatureFlagKeyEnum } from './FeatureFlagKeyEnum'
import { CustomerLayoutChoiceEnum, CustomerLayoutChoiceMetadata } from './choices/CustomerLayoutChoice'
import { ComplexEditorLayoutChoiceEnum, ComplexEditorLayoutChoiceMetadata } from './choices/ComplexEditorLayoutChoice'

export interface FeatureFlagChoiceConfig<T extends string = string> {
  choices: readonly T[]
  defaultChoice: T
  metadata: Record<T, { name: string; description: string }>
}

export const FeatureFlagChoiceMapping: Record<FeatureFlagKeyEnum, FeatureFlagChoiceConfig> = {
  [FeatureFlagKeyEnum.CUSTOMER_LAYOUT]: {
    choices: Object.values(CustomerLayoutChoiceEnum),
    defaultChoice: CustomerLayoutChoiceEnum.TREE,
    metadata: CustomerLayoutChoiceMetadata,
  },
  [FeatureFlagKeyEnum.COMPLEX_EDITOR_LAYOUT]: {
    choices: Object.values(ComplexEditorLayoutChoiceEnum),
    defaultChoice: ComplexEditorLayoutChoiceEnum.POPOVER,
    metadata: ComplexEditorLayoutChoiceMetadata,
  },
}
